export default function auth(nav) {
  let user = localStorage.getItem("user");
  if (nav.to.name !== "login" && localStorage.getItem("token") === null) {
    return (window.location.href = "/login");
  } else {
    if (user !== null && JSON.parse(user).is_registered_compelete === 0) {
      return (window.location.href = "/sign-up");
    } else {
      return nav.next();
    }
  }
}
